export default {
      id: "tenge-usage",
      viewBox: "0 0 13 17",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#tenge",
      toString: function () {
        return this.url;
      }
    }